import ArrowBack from "@mui/icons-material/ArrowBack";
import { Button, Stack, useTheme } from "@mui/material";
import { mdHeight, xsHeight } from "components/AppBar";
import { TAB_LINKS_HEIGHT } from "components/TabLinks";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

/** The shell shared by the invoice and audit detail pages. */
export function InvoiceTrackingDetailPage({
  backLink,
  backLabel,
  actions,
  children,
}: {
  backLink: string;
  backLabel: string;
  actions?: ReactNode;
  children: ReactNode;
}) {
  const theme = useTheme();
  return (
    <Stack
      spacing={3}
      sx={{
        p: 3,
        bgcolor: "canvas",
        minHeight: {
          xs: `calc(100vh - ${theme.spacing(xsHeight)} - ${TAB_LINKS_HEIGHT}px)`,
          md: `calc(100vh - ${theme.spacing(mdHeight)} - ${TAB_LINKS_HEIGHT}px)`,
        },
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        useFlexGap
        gap={1}
      >
        <Button component={Link} to={backLink} startIcon={<ArrowBack />}>
          {backLabel}
        </Button>
        {actions && (
          <Stack direction="row" flexWrap="wrap" useFlexGap gap={1}>
            {actions}
          </Stack>
        )}
      </Stack>
      {children}
    </Stack>
  );
}
